// extracted by mini-css-extract-plugin
export default {"recent-item-wrapper":"RecentItem_recent-item-wrapper__dErIF","recent-item":"RecentItem_recent-item__Svkkf","centered":"RecentItem_centered__FH8kk"};